import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import HorizontalScroll from '@components/HorizontalScroll';

import BrandFilterLeftSidePanel from '@features/trend-research/components/onboarding/components/BrandFilterLeftSidePanel';
import TrendTopFilter from '@features/trend-research/components/onboarding/components/TrendTopFilter';

import { toggleSelectedBrandForFilter } from '@store/actions/trend-research/TrendResearchAction';
import {
	useSelectedBrands,
	useTrendResearchOnboardedBrands
} from '@store/reducers/trend-research/TrendResearchReducer';

import { changeDateFormat } from '@utils/Util';

const OnboardedBrands = () => {
	const dispatch = useDispatch();
	const scrollRef = useRef(null);
	const selectedBrands = useSelectedBrands();
	const brands = useTrendResearchOnboardedBrands();
	const [isShowFilter, setIsShowFilter] = useState(false);
	const brandList = brands.filter((brand) => selectedBrands.includes(brand.code));

	const renderBrands = () => {
		const toggleBrandSelection = (brandCode) => {
			dispatch(toggleSelectedBrandForFilter({ selectedCode: brandCode }));
		};

		return brandList?.map((brand, idx) => {
			return (
				<div
					className="brand-single mr-3 d-flex align-items-center align-self-center flex-column justify-content-center"
					key={`brand_${idx}`}
				>
					{brand.brandLogoDocResponse?.docUrl && (
						<img className="logo-img" src={brand.brandLogoDocResponse.docUrl} alt="" />
					)}
					<p className="regular-12 gray_dark_01">{brand.noOfProducts} Products</p>
					<div className="overly radius-4 d-flex align-items-center align-self-center flex-column justify-content-center">
						<div
							className="close-img cursor-pointer d-flex justify-content-center align-items-center"
							onClick={() => toggleBrandSelection(brand.code)}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} width={20} alt="" />
						</div>
					</div>
					<p className="brand-title gray_dark_02 weight-500 regular-12">{brand?.name}</p>
					<p className="brand-date gray_dark_02 weight-500 regular-12">
						Last update: {changeDateFormat(brand.lastDownloadDate, 'YYYY-MM-DD', 'DD MMM, YYYY')}
					</p>
				</div>
			);
		});
	};

	const toggleIsShowFilter = () => {
		setIsShowFilter(false);
	};

	const totalBrandWiseProducts = brands?.reduce((total, brand) => (total += brand.noOfProducts), 0);

	return (
		<div className="brand-section scrollbar-on-hover">
			<TrendTopFilter title="Brands" type="Brand" />
			<div className="d-flex">
				<div className="brand-select-btn white-bg mr-3 cursor-pointer">
					<div className="brand-single d-flex align-items-center align-self-center flex-column justify-content-center">
						<div onClick={() => setIsShowFilter(true)}>
							<p className="mb-12 d-flex">
								Select Brand{' '}
								<span>
									<img src={`${process.env.PUBLIC_URL}/icons/right-arrow.svg`} alt="" />
								</span>
							</p>
							<p className="regular-12 gray_dark_01">{totalBrandWiseProducts} Products</p>
						</div>
					</div>
				</div>
				<div className="d-flex brand-items trending-slider scroll-x-label" ref={scrollRef}>
					{brandList.length > 0 && <HorizontalScroll elementReference={scrollRef.current} />}
					{renderBrands()}
				</div>
			</div>
			<BrandFilterLeftSidePanel
				isShowFilter={isShowFilter}
				toggleIsShowFilter={toggleIsShowFilter}
				brandList={brands}
			/>
		</div>
	);
};

export default OnboardedBrands;
